import { type UseQueryResult, useQuery } from 'react-query';
import { TableParams } from '../../types/common';
import {
  TradeOrderService,
  Wealthlane_AwardSettlementService_Dtos_TradeOrder_PlaceOrderDashboardDto,
} from '../../services/wealthlane-award-settlement-services';
import moment from 'moment';
import { DATE_FORMAT } from '../../constants/common';

const useGetTradeOrderPlaceOrdersDashboard = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParams
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Array<Wealthlane_AwardSettlementService_Dtos_TradeOrder_PlaceOrderDashboardDto> | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount, orderStatusId, cancelStatusId, _force } =
    tableInfo;

  const getTradeOrderPlaceOrders = useQuery(
    [
      'getTradeOrderPlaceOrdersDashboard',
      orderStatusId,
      cancelStatusId,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        TradeOrderService.getApiAwardSettlementApiAppTradeOrderPlacedOrdersDashboard(
          [orderStatusId],
          [cancelStatusId]
        )
      );
    },
    {
      select: (data) =>
        data?.map((item: any) => {
          return { ...item, createdDate: moment(item.createdDate).format(DATE_FORMAT) };
        }),
    }
  );

  return getTradeOrderPlaceOrders;
};

export default useGetTradeOrderPlaceOrdersDashboard;
